// App-side delegate for `@heidi/templates/data` (D2.3, ARCFE-1029).
//
// Everything severed here is an app reaction fired at its original position:
// two toasts (legacy i18next copy, byte-identical) and two analytics dispatches
// (`trackTemplateDeleted` before the request, `trackGlobalTemplateDeleted`
// nested inside the organization-manager branch).
//
// `isOrganizationTemplateManager` crosses as a value — see the package hook for
// why the S5 "wait for OT3" framing describes an event that cannot happen.
import { trackGlobalTemplateDeleted } from '@/lib/analytics/scribe/global-template';
import { trackTemplateDeleted } from '@/lib/analytics/scribe/template';
import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { useMutateDeleteTemplate as useMutateDeleteTemplateCore } from '@heidi/templates/data';
import { useCombinedOrganizationInfo } from '../query/useCombinedOrganizationInfo';

export function useMutateDeleteTemplate() {
  const { t } = useTranslations();
  const { isOrganizationTemplateManager } = useCombinedOrganizationInfo();

  return useMutateDeleteTemplateCore({
    isOrganizationTemplateManager,
    onTemplateDeleted: (templateId) => trackTemplateDeleted(templateId),
    onGlobalTemplateDeleted: (templateId) => trackGlobalTemplateDeleted(templateId),
    onDeleted: () => {
      toast({ tone: 'success', title: t('common.templateDeleted') });
    },
    onDeleteFailed: (description) => {
      toast({
        tone: 'destructive',
        title: t('common.failedToDeleteTemplate'),
        description,
      });
    },
  });
}
